<template>
    <div class="snackbar" :class="getClasses()">
        <i class="fa fa-envelope"></i>
        <span>{{message}}</span>
        <i class="fa fa-times " @click="hide()"></i>
    </div>
</template>

<script>
    export default {
        name: "np-snackbar",
        props: {
        },
        data: function() {
            return {
                shouldShow: false,
                type: 'info',
                message: String,
            }
        },
        methods: {
            getClasses() {
                return {
                    show: this.shouldShow,
                    info: this.type === 'info',
                    error: this.type === 'error',
                    success: this.type === 'success'
                }
            },
            show(message, config) {
                this.shouldShow = true;
                this.message = message;
                if(config) {
                    if (config.type) {
                        this.type = config.type
                    }
                }
            },
            hide() {
                this.shouldShow = false;
            }
        }
    }
</script>

<style scoped>

    /* The snackbar - position it at the bottom and in the middle of the screen */
    .snackbar {
        display:flex;
        justify-content: space-between;
        align-items: center;
        /*visibility: hidden; !* Hidden by default. Visible on click *!*/
        min-width: 250px; /* Set a default minimum width */
        margin-left: -125px; /* Divide value of min-width by 2 */
        background-color: #333; /* Black background color */
        color: #fff; /* White text color */
        text-align: center; /* Centered text */
        border-radius: 2px; /* Rounded borders */
        padding: 10px 30px; /* Padding */
        position: fixed; /* Sit on top of the screen */
        z-index: 1; /* Add a z-index if needed */
        left: 50%; /* Center the snackbar */
        bottom: -30px; /* 30px from the bottom */
        opacity: 0;
        transition: all .3s ease;
        font-size:14px;

    }

    .show {
        /*visibility: visible !important; !* Show the snackbar *!*/

        /* Add animation: Take 0.5 seconds to fade in and out the snackbar.
        However, delay the fade out process for 2.5 seconds */
        /*-webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;*/
        /*animation: fadein 0.5s, fadeout 0.5s 2.5s;*/
        /*-webkit-animation: fadein 0.5s;*/
        display: flex !important;
        bottom: 0; /* 30px from the bottom */
        opacity: 1;
    }

    .info {
        color: #004085;
        background-color: #cce5ff;
        border-color: #b8daff;
    }

    .success {
        color: white;
        background-color: rgba(46, 204, 113, .95);
        border-color: #c3e6cb;
    }

    .error {
        color:#721c24;
        background-color: #f8d7da;
        border-color: #f5c6cb;
    }

    /* Show the snackbar when clicking on a button (class added with JavaScript) */
    .hide {
        /*-webkit-animation: fadeout 0.5s;*/
    }

    /* Animations to fade the snackbar in and out */
    @-webkit-keyframes fadein {
        from {bottom: 0; opacity: 0;}
        to {bottom: 30px; opacity: 1;}
    }

    @keyframes fadein {
        from {bottom: 0; opacity: 0;}
        to {bottom: 30px; opacity: 1;}
    }

    @-webkit-keyframes fadeout {
        from {bottom: 30px; opacity: 1;}
        to {bottom: 0; opacity: 0;}
    }

    @keyframes fadeout {
        from {bottom: 30px; opacity: 1;}
        to {bottom: 0; opacity: 0;}
    }

</style>